import * as React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';

import { SelectHandler } from '@app/Components/SelectFilter';
import { ReactSelectSize } from '@app/Components/ReactSelect';
import FilterContainer from '@app/Components/Filters/FilterContainer';
import InstructorPicker from '@app/Components/Pickers/InstructorPicker';
import { applyDecorators } from "@app/Helpers/Decorator";

type TypeRatingFilterProps = {
    clearable?: boolean;
    multi?: boolean;
    value: string | null;
    size?: string;
    selectedCrewFunction?: string | null;
    onSelect?: SelectHandler;
    className?: string;
    selectSize?: ReactSelectSize;
};

@observer
export default class InstructorFilter extends React.Component<TypeRatingFilterProps> {
    
    constructor (props: TypeRatingFilterProps) {
        super(props);
        applyDecorators(this);
    }

    render () {
        const { clearable, value, size, className, selectSize, selectedCrewFunction, multi } = this.props;
        return (
            <FilterContainer title="Instructor" size={size} className={className}>
                <InstructorPicker clearable={clearable} multi={multi} value={value} selectSize={selectSize} selectedCrewFunction={selectedCrewFunction} onSelect={this._onChangeHandler} />
            </FilterContainer>
        );
    }

    @action.bound
    private _onChangeHandler (selected: string | null) {
        this.props.onSelect && this.props.onSelect({ value: selected });
    }
}
